
const routes = [
    {
        path: "/turkmer/application/list",
        component: () => import("../pages/applicationList/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "",
            // turkmerapplication_index
        },
    },
    {
        path: "/turkmer/application/:id",
        component: () => import("../pages/ApplicationFormUpdate.vue"),
        meta: {
            isAuthenticated: true,
            permission: "",
        },
    }
];

export default routes;
